import { notification } from "antd";
import { createElement } from "react";
import { Icon } from "@iconify/react";

type ToastVariant = "success" | "error" | "warning" | "info";

const VARIANT_ICON: Record<ToastVariant, string> = {
  success: "lucide:check-circle-2",
  error: "lucide:x-circle",
  warning: "lucide:alert-triangle",
  info: "lucide:info",
};

const VARIANT_COLOR: Record<ToastVariant, string> = {
  success: "#027A48",
  error: "#E4002B",
  warning: "#F59E0B",
  info: "#2563EB",
};

function fire(variant: ToastVariant, message: string, durationMs: number, description?: string) {
  notification.open({
    message: createElement(
      "p",
      { className: "text-sm font-medium leading-snug text-[#262626] m-0" },
      message,
    ),
    description: description
      ? createElement("p", { className: "text-xs leading-snug text-[#6B7280] m-0 mt-1" }, description)
      : undefined,
    icon: createElement(Icon, { icon: VARIANT_ICON[variant], className: "h-6 w-6", style: { color: VARIANT_COLOR[variant] } }),
    placement: "topRight",
    duration: durationMs / 1000,
    // closeIcon left at antd's default (shown) — every one of these notifications
    // is dismissible by hand, not just on the auto-dismiss timer.
    className: "!w-96 !rounded-lg !border !border-black/5 !shadow-lg",
  });
}

const AUTO_DISMISS_MS = 4000;

export function toastSuccess(message: string) {
  fire("success", message, AUTO_DISMISS_MS);
}
export function toastError(message: string) {
  fire("error", message, AUTO_DISMISS_MS);
}
export function toastWarning(message: string, durationMs: number = AUTO_DISMISS_MS) {
  fire("warning", message, durationMs);
}
export function toastInfo(message: string, description?: string, durationMs: number = AUTO_DISMISS_MS) {
  fire("info", message, durationMs, description);
}